import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { debounce } from '../../utils/utils';

const useActivityCheckEvent = ({ handleUserActivity }) => {
  const dispatch = useDispatch();
  const startLoggingProcess = debounce(() => dispatch(handleUserActivity('Filling Form')), 3000);
  const activityCheckEventCallBack = (e) => {
    const eventElementHasNoForm = !e.target.form;
    if (eventElementHasNoForm) return;

    const eventElement = e.target;
    const eventType = e.type;

    switch (eventType) {
      case 'change': {
        const isInputOfTypeCheckboxOrRadio =
          (eventElement.localName === 'input' && eventElement.type === 'checkbox') || eventElement.type === 'radio';
        if (isInputOfTypeCheckboxOrRadio) startLoggingProcess();
        break;
      }
      case 'keyup': {
        const isInputOfTypeCheckboxOrRadio =
          eventElement.localName === 'input' || eventElement.localName === 'textarea';
        if (isInputOfTypeCheckboxOrRadio) startLoggingProcess();
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    document.addEventListener('change', activityCheckEventCallBack);

    return () => document.removeEventListener('change', activityCheckEventCallBack);
  }, []);

  useEffect(() => {
    document.addEventListener('keyup', activityCheckEventCallBack);

    return () => document.removeEventListener('keyup', activityCheckEventCallBack);
  }, []);
};

export default useActivityCheckEvent;
